import { render, staticRenderFns } from "./ProductPricingPlansModal.vue?vue&type=template&id=ba5369b4"
import script from "./ProductPricingPlansModal.vue?vue&type=script&lang=js"
export * from "./ProductPricingPlansModal.vue?vue&type=script&lang=js"
import style0 from "./ProductPricingPlansModal.vue?vue&type=style&index=0&id=ba5369b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports